import { render } from "./CreatorNotificationManagementSettings.vue?vue&type=template&id=24f5f915"
import script from "./CreatorNotificationManagementSettings.vue?vue&type=script&lang=js"
export * from "./CreatorNotificationManagementSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__